import { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import EdSwitch from '@/components/forms/EdSwitch'
import EdTextfield from '@/components/forms/EdTextfield'

interface Condizione {
  id_condizione: string;
  nome_condizione: string;
  descrizione_condizione: string;
  attivo: string;
}

interface CondizioniSectionProps {
  isReadOnly?: boolean;
  data?: Condizione[];
}

const CondizioniSection = ({ isReadOnly = false, data = [] }: CondizioniSectionProps) => {
  const { watch, setValue, register } = useFormContext();
  const [isAddingNew, setIsAddingNew] = useState(false);
  const [newCondizione, setNewCondizione] = useState({ nomeEtichetta: '', descrizione: '' });

  const selections = watch('condizioniSelezionati') || {};

  const handleStartAdding = () => {
    setIsAddingNew(true);
    setNewCondizione({ nomeEtichetta: '', descrizione: '' });
    setValue('tempNomeEtichetta', '');
    setValue('tempDescrizione', '');
  };

  const handleCancelAdding = () => {
    setIsAddingNew(false);
    setNewCondizione({ nomeEtichetta: '', descrizione: '' });
    setValue('tempNomeEtichetta', '');
    setValue('tempDescrizione', '');
  };

  const handleSaveCondizione = () => {
    if (newCondizione.nomeEtichetta.trim() && newCondizione.descrizione.trim()) {
      // TODO: chiamare API per creare nuova condizione
      console.log('Nuova condizione:', newCondizione);
      handleCancelAdding();
    }
  };

  const handleInputChange = (field: 'nomeEtichetta' | 'descrizione', value: string) => {
    setNewCondizione(prev => ({ ...prev, [field]: value }));
  };

  return (
    <div className="flex flex-col gap-1">
      <span className="text-[20px] text-black font-bold mt-2">Condizioni</span>

      <div className="w-full">
        {data.length > 0 && data.map((item, idx) => {
            const checked = item.attivo === '1' || !!selections?.[item.id_condizione];
            return (
              <div
                key={item.id_condizione}
                className={`flex items-center justify-between px-0 py-1.5 transition-all duration-300 ease-in-out ${idx !== data.length - 1 ? 'border-b border-gray-200' : ''}`}
              >
                <div className="flex items-center gap-12">
                  <span className="text-sm text-black min-w-[180px]">{item.nome_condizione}</span>
                  <span className="text-sm text-gray-500">{item.descrizione_condizione}</span>
                </div>
                <div className="flex items-center gap-2">
                  <EdSwitch
                    id={`condizioni-${item.id_condizione}`}
                    value={checked}
                    onChange={() => setValue(`condizioniSelezionati.${item.id_condizione}`, !checked, { shouldDirty: true })}
                    disabled={isReadOnly}
                  />
                  <span className={`text-sm ${checked ? 'text-black' : 'text-gray-400'}`}>Selezionato</span>
                </div>
              </div>
            );
        })}
      </div>

      {/* Inline Add Form */}
      {isAddingNew && !isReadOnly ? (
        <div className="flex items-center justify-between px-0 py-1.5 border-b border-gray-200 transition-all duration-300 ease-in-out">
          {/* Left side - Input fields */}
          <div className="flex items-center gap-4">
            <div className="w-48">
              <EdTextfield
                label="Nome etichetta*"
                id="new-nome-etichetta"
                type="text"
                placeholder="Nome etichetta"
                register={{
                  ...register('tempNomeEtichetta'),
                  onChange: (e: React.ChangeEvent<HTMLInputElement>) => handleInputChange('nomeEtichetta', e.target.value)
                }}
              />
            </div>
            <div className="w-48">
              <EdTextfield
                label="Descrizione*"
                id="new-descrizione"
                type="text"
                placeholder="Descrizione"
                register={{
                  ...register('tempDescrizione'),
                  onChange: (e: React.ChangeEvent<HTMLInputElement>) => handleInputChange('descrizione', e.target.value)
                }}
              />
            </div>
          </div>

          {/* Right side - Buttons */}
          <div className="flex items-center gap-2">
            <button
              onClick={handleSaveCondizione}
              className="rounded bg-red-700 px-6 pb-2.5 pt-2.5 text-sm border-none ring-0 outline-none font-medium uppercase leading-normal text-white transition duration-150 ease-in-out hover:bg-red-700"
            >
              CONFERMA
            </button>
            <button
              onClick={handleCancelAdding}
              className="px-6 pb-2.5 pt-2.5 bg-primary-100 rounded text-sm font-medium border-none ring-0 outline-none uppercase leading-normal text-primary-800 transition duration-150 ease-in-out hover:bg-gray-300"
            >
              ANNULLA
            </button>
          </div>
        </div>
      ) : !isReadOnly ? (
        <span
          className="text-sm text-[#B80F15] font-bold cursor-pointer hover:text-[#9a0c11] transition-colors duration-200"
          onClick={handleStartAdding}
        >
          + Aggiungi condizione
        </span>
      ) : null}
    </div>
  )
}

export default CondizioniSection
